import React from "react";
import Left from "./left";
import Right from "./right";
import { TProductDetail } from "../../types";

const Showcase = ({ products }: { products?: TProductDetail[] }) => {
  return (
    <section className="grid w-full grid-cols-1 gap-2 md:grid-cols-2" id="home">
      <Left />
      <Right products={products} />
    </section>
  );
};

export default Showcase;
